export const OkrEN = {
    "okr": "OKRs",
    "periodOkrSetting": "Chu kỳ OKRS",
    "OkrLabelSetting": "Cài đặt",
    "periodCheckin": "Cài đặt",
    "statusCheckin": "Cài đặt",
    "checkInQuestionGroup":"Nhóm câu hỏi checkin"
}